/** @jsxImportSource theme-ui */
import React from 'react';

import * as dto from 'client/dto';
import { getRiskLikelihood, getRiskMagnitude } from 'utils/modelHelpers';

import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';

interface AirportItemProps {
  airport: dto.GetAirportRiskModel;
}

export const AirportImportationItem: React.FC<AirportItemProps> = ({ airport }) => {
  const { name, city, importationRisk: risk } = airport;
  const travellers = getRiskMagnitude(risk);
  const likelihoodText = getRiskLikelihood(risk);
  return (
    <FlexGroup
      suffix={
        <div sx={{ textAlign: 'right' }}>
          <Typography variant="subtitle2" color="stone90">
            {likelihoodText}
          </Typography>
          <Typography variant="subtitle2" color="stone90">
            {travellers}
          </Typography>
        </div>
      }
    >
      <Typography variant="subtitle2" color="stone90">
        {name}
      </Typography>
      <Typography variant="caption" color="deepSea50">
        {city}
      </Typography>
    </FlexGroup>
  );
};

export const AirportExportationItem: React.FC<AirportItemProps> = ({ airport }) => {
  const { name, city, exportationRisk: risk } = airport;
  const travellers = getRiskMagnitude(risk);
  const likelihoodText = getRiskLikelihood(risk);
  return (
    <FlexGroup
      suffix={
        <div sx={{ textAlign: 'right' }}>
          <Typography variant="subtitle2" color="stone90">
            {likelihoodText}
          </Typography>
          <Typography variant="subtitle2" color="stone90">
            {travellers}
          </Typography>
        </div>
      }
    >
      <Typography variant="subtitle2" color="stone90">
        {name}
      </Typography>
      <Typography variant="caption" color="deepSea50">
        {city}
      </Typography>
    </FlexGroup>
  );
};
